export const verifyIsNumber = (intValue) => {
  const re = /^[0-9]*$/;
  return { passed: re.test(intValue), intValue: intValue };
};

export default verifyIsNumber;
